/* Turakhia Eyewear - display-only currency converter for the topbar switcher.
   Prices are shown in the chosen currency (live keyless rates from open.er-api.com);
   checkout still charges the store currency. Reads config from [data-currency-config],
   selection UI = [data-cc-set] links, trigger label = [data-cc-label]. */
(function () {
  if (window.__ccInit) return; window.__ccInit = true;

  var cfgEl = document.querySelector('[data-currency-config]');
  if (!cfgEl) return;
  var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg || !cfg.base) return;

  var BASE = cfg.base;                       // e.g. "INR"
  var KEY = 'cc-currency', RATES_KEY = 'cc-rates-' + BASE, TTL = 6 * 3600 * 1000;
  var selected = (function () { try { return localStorage.getItem(KEY) || BASE; } catch (e) { return BASE; } })();
  var rates = null, observer = null;

  // Money token regex - match the custom symbol plus common INR symbols.
  function esc(s) { return String(s).trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  var syms = [cfg.baseSymbol || '₹', '₹', 'Rs.', 'Rs'].filter(Boolean).map(esc);
  var MONEY = new RegExp('(?:' + syms.join('|') + ')\\s?\\d[\\d,]*(?:\\.\\d+)?', 'g');
  var SELECTORS = '.price, .ct__now, .ct__was, .money, .totals__subtotal-value, .totals__total-value, .totals__discount-value, [data-cc-money]';

  // Extract the numeric value from a money token, ignoring the symbol/letters
  // (e.g. "Rs. 49,980.00" -> 49980, "₹1,23,456.00" -> 123456).
  function parseAmt(str) { var m = String(str).match(/\d[\d,]*(?:\.\d+)?/); return m ? (parseFloat(m[0].replace(/,/g, '')) || 0) : 0; }
  function symbolOf(code) {
    try { var p = new Intl.NumberFormat('en', { style: 'currency', currency: code, maximumFractionDigits: 0 }).formatToParts(0); var s = p.find(function (x) { return x.type === 'currency'; }); return s ? s.value : code; }
    catch (e) { return code; }
  }
  function fmt(amount, code) {
    try {
      var whole = Math.abs(amount % 1) < 0.005;
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: code, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(amount);
    } catch (e) { return symbolOf(code) + amount.toFixed(2); }
  }

  function convertEl(el) {
    var cur = el.innerHTML;
    // If the theme (re)rendered this price, re-capture the original base HTML.
    if (el.__ccOut === undefined || cur !== el.__ccOut) el.__ccOrig = cur;
    var rate = selected === BASE ? 1 : (rates && rates[selected]);
    var out;
    if (selected === BASE || !rate) {
      out = el.__ccOrig;
    } else {
      out = el.__ccOrig.replace(MONEY, function (m) { return fmt(parseAmt(m) * rate, selected); });
      out = out.replace(new RegExp('\\b' + esc(BASE) + '\\b', 'g'), selected); // "money_with_currency": INR -> USD
    }
    if (cur !== out) el.innerHTML = out;
    el.__ccOut = out;
  }

  function convertAll() {
    if (observer) observer.disconnect();
    try { document.querySelectorAll(SELECTORS).forEach(convertEl); } catch (e) {}
    updateUI();
    if (observer) observer.observe(document.body, { childList: true, subtree: true });
  }

  function updateUI() {
    var label = selected + ' ' + symbolOf(selected);
    document.querySelectorAll('[data-cc-label]').forEach(function (l) { l.textContent = label; });
    document.querySelectorAll('[data-cc-set]').forEach(function (a) {
      var on = a.getAttribute('data-cc-set') === selected;
      a.classList.toggle('active', on);
      a.classList.toggle('pointer-events-none', on);
      if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
  }

  function loadRates(done) {
    try { var c = JSON.parse(localStorage.getItem(RATES_KEY)); if (c && c.rates && (Date.now() - c.t) < TTL) { rates = c.rates; return done(); } } catch (e) {}
    fetch('https://open.er-api.com/v6/latest/' + BASE).then(function (r) { return r.json(); }).then(function (d) {
      if (d && d.rates) { rates = d.rates; try { localStorage.setItem(RATES_KEY, JSON.stringify({ rates: rates, t: Date.now() })); } catch (e) {} }
      done();
    }).catch(function () { done(); });
  }

  // Choosing a currency
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cc-set]'); if (!a) return;
    e.preventDefault();
    selected = a.getAttribute('data-cc-set');
    try { localStorage.setItem(KEY, selected); } catch (e2) {}
    var apply = function () { convertAll(); };
    if (selected !== BASE && !(rates && rates[selected])) loadRates(apply); else apply();
    // close the dropdown the same way the theme does (Esc)
    document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
    if (a.blur) a.blur();
  });

  // init
  observer = new MutationObserver(function () { if (selected === BASE) return; clearTimeout(observer.__t); observer.__t = setTimeout(convertAll, 150); });
  function start() { if (selected !== BASE) loadRates(convertAll); else { convertAll(); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
